import i18next, { type i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import deBundle from './de.json';
import enBundle from './en.json';
import { DEFAULT_LOCALE, Locale, SUPPORTED_LOCALES } from './locale.js';

/**
 * Resource-Namespace, unter dem alle UI-Strings registriert werden. Eine
 * flache Struktur reicht für das aktuelle Scope; spätere Erweiterungen
 * (z. B. eigenes Namespace für Praxis-Mikrocopy) können hier andocken.
 */
export const NAMESPACE = 'translation';

/**
 * Initialisiert die i18next-Instanz mit den eingebauten DE/EN-Bundles und
 * dem React-Adapter. Nicht-blockierend (Bundles sind statisch importiert,
 * also synchron verfügbar).
 *
 * @param initialLocale Sprache, mit der die App startet (z. B. aus `sessionStorage`).
 */
export async function createI18nInstance(initialLocale: Locale): Promise<I18nInstance> {
  await i18next.use(initReactI18next).init({
    lng: initialLocale,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    ns: [NAMESPACE],
    defaultNS: NAMESPACE,
    resources: {
      [Locale.De]: { [NAMESPACE]: deBundle },
      [Locale.En]: { [NAMESPACE]: enBundle },
    },
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });
  return i18next;
}
